export const CustomTooltip = ({ active, payload, label }) => {
  console.log(active,payload,label)
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{`${label}`}</p>
          <div>
            {payload.map((pld) => (
              <div style={{ display: "inline-block", padding: 10 }}>
                {/* string.replace(/[|&;$%@"<>()+,]/g, ""); */}
                <div style={{ color: pld.color }}>{pld.dataKey.replace("00000", "")} : </div>
                <div style={{ color: pld.fill }}>&nbsp; {pld.value}</div><br/>
                
              </div>
            ))}
          </div>
        </div>
      );
    }
  
    return null;
  };
  